module.exports = __webpack_public_path__ + "img/29.e43927c4.jpg";